<template>
  <Dialog title="Create subscription" :show="isOpen" :onClose="onClose">
    <el-form label-width="120px" label-position="left" size="small">
      <el-form-item label="Service">
        <el-radio-group v-model="service">
          <el-radio label="stripe">Stripe</el-radio>
          <el-radio label="paypal">PayPal</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Plan">
        <el-radio-group v-model="plan">
          <el-radio label="prototype">Basic</el-radio>
          <el-radio label="pro">Pro</el-radio>
          <el-radio label="team">Team</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Interval">
        <el-radio-group v-model="interval">
          <el-radio label="annually">Annually</el-radio>
          <el-radio label="monthly">Monthly</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Seats">
        <el-input-number
          v-model="payload.quantity"
          :min="minSeats"
          :step="1"
          step-strictly
        />
      </el-form-item>
      <el-form-item label="Subscription ID" required>
        <el-input v-model="payload.subscription_id" />
      </el-form-item>

      <el-form-item>
        {{ planId }}
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">Create</el-button>
        <el-button @click="onClose()">Cancel</el-button>
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import { get } from "lodash";
import { mapGetters, mapActions } from "vuex";
import Dialog from "@/components/Dialog";

const isDev = process.env.NODE_ENV === "development";

const PLAN_IDS = {
  stripe: {
    prototype: {
      monthly: "anima-prototype-monthly-29",
      annually: "anima-prototype-annually-25-1",
    },
    pro: {
      monthly: "anima-monthly-39",
      annually: "anima-pro-annually-31",
    },
    team: {
      monthly: "anima-team-monthly-32",
      annually: "anima-team-annually-26",
    },
  },
  paypal: {
    prototype: {
      monthly: isDev
        ? "P-7Y423058HL6858901L36NMVY"
        : "P-9L615356WX143364PL4A62EY",
      annually: isDev
        ? "P-19K066423P254805UL36NNEA"
        : "P-8WS045422U1104428L4A62WI",
    },
    pro: {
      monthly: isDev
        ? "P-5W883008BC517343YL36NN5Y"
        : "P-8DW290690C195015FL4A6ZWA",
      annually: isDev
        ? "P-8D162782P50238434L36NNRY"
        : "P-0Y9909335R883851DL4A6ZLA",
    },
    team: {
      monthly: isDev
        ? "P-1HD93160J38597406MAJLL4A"
        : "P-8WH54102DM9735331MAJLNQI",
      annually: isDev
        ? "P-7AE59105GV4041848MAIDPZA"
        : "P-6P5967597H026702GMAIDTNY",
    },
  },
};

export default {
  data() {
    return {
      plan: "pro",
      interval: "annually",
      service: "paypal",
      payload: {
        quantity: 1,
        is_trial: false,
        subscription_id: "",
        is_test: false,
      },
    };
  },
  props: {
    item: Object,
    isOpen: Boolean,
    onClose: Function,
  },
  components: {
    Dialog,
  },
  computed: {
    ...mapGetters(["loading"]),
    planId() {
      const { plan, interval, service } = this;
      return get(PLAN_IDS, [service, plan, interval]);
    },
    minSeats() {
      return this.plan === "team" ? 3 : 1;
    },
  },
  methods: {
    ...mapActions(["getTeamSubscriptions"]),
    async save() {
      const { payload, item: team, service, planId } = this;
      try {
        const url = `/cs/teams/${team.id}/subscription`;
        if (!payload.subscription_id) {
          return this.$notify.error({
            title: "Failed creating subscription",
            message: "Please provide a subscription ID.",
          });
        }

        await this.$api({
          url,
          method: "post",
          data: { ...payload, service, plan_id: planId },
        });

        this.$message.success("Created successfully");
        this.onClose();
      } catch (e) {
        this.$notify.error({
          title: "Failed creating subscription",
          message: e.message,
        });
      } finally {
        this.getTeamSubscriptions(team.id);
      }
    },
  },
};
</script>

<style scoped>
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
